export default __webpack_public_path__ + "static/media/Leggings of Vicious Frenzy.15462537.jpg";